import { z } from "zod";

export const UserSimplified = z.object({
  id: z.string(),
  name: z.string().optional(),
  display_name: z.string().optional(),
  image_url: z.string().optional(),
  email: z.string().optional(),
  admin: z.boolean().optional(),
});

export type UserSimplified = z.infer<typeof UserSimplified>;
